
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BorderContainer extends Vue {
  @Prop({ default: undefined }) grey!: any;
}
